<template>
  <div class="meet-us">
    <div class="section">
      <p class="header">Meet us</p>
      <p class="desc gt-xs">
        We develop software for fintech companies used by thousands of users all around world.
        We aim to make our UX accessible for everyone.
      </p>
    </div>
    <div class="section">
      <img class="icon icon--pin" src="@/assets/icon_pin.png"/>
      <p class="bold">3 Ashley Road</p>
      <p>Bournemouth, England, BH1 4LE</p>
    </div>
    <div class="section">
      <img class="icon icon--email" src="@/assets/icon_email.png"/>
      <div>
        <a class="line-link" href="mailto:contact@feat.software">contact@feat.software</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeetUs',
};
</script>

<style lang="stylus" scoped>
  @import '../../styles/variables';


  .meet-us {
    padding-top: 135px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 65px;
    max-width: 580px;
    margin: 0 auto;

    /* does cool transition on breakpoint change */
    * {
      transition: margin 0.3s, padding 0.3s;
    }
  }

  .section{
    margin-bottom: 20px;
    &:last-child{
      margin-bottom: 0;
    }
  }

  p, a{
    font-size: 16px;
  }

  a{
    display: inline-block;
    line-height: 36px;
    color: #40B8FF;
    font-weight: 300;

    &:visited{
      color: #40B8FF;
    }
  }

  p{
    line-height: 26px;
  }

  .icon{
    margin-bottom: 10px;
  }

  .header{
    font-family: 'Dosis', sans-serif;
    font-weight: 200;
    font-size: 38px;
    line-height: 47px;
  }


  @media(min-width: $breakpoint-sm-min){
    .meet-us{
      padding-bottom: 90px;
    }

    .header{
      margin-bottom: 45px;
      font-size: 60px;
      line-height: 67px;
    }

    .desc{
      font-size: 20px;
      line-height: 36px;
    }

    .section{
      margin-bottom: 40px;
    }

    .icon{
      margin-bottom: 30px;
    }
    p,a{
      font-size: 20px;
      line-height: 36px;
    }
    a{
      line-height: 44px;
    }
  }


  @media(min-width: $breakpoint-md-min) {
    .meet-us{
      padding-top: 0;
      padding-bottom: 0;
      padding-left: 0;
      padding-right: 0;
      max-width: 450px;
      margin: 0;
    }
    .section{
      margin-bottom: 30px;
    }
    .icon{
      margin-bottom: 10px;
    }
    .header{
      margin-bottom: 35px;
    }
  }

  @media(min-width: $breakpoint-lg-min) {
    .header{
      font-size: 80px;
      line-height: 91px;
      margin-bottom: 25px;
    }
    p, .desc{
      font-size: 22px;
      line-height: 36px;
    }
    a{
      font-size: 22px;
      line-height: 49px;
    }
    .section{
      margin-bottom: 40px;
    }
  }
</style>
